// Product catalog with brand colors for placehold.co images

export interface MockProduct {
  key: string;
  name: string;
  color: string;     // hex background (no #)
  textColor: string;  // hex text (no #)
  upc: string;
}

export const PRODUCTS: Record<string, MockProduct> = {
  'coca-cola': { key: 'coca-cola', name: 'Coca-Cola', color: 'DC2626', textColor: 'FFF', upc: '5449000000996' },
  'coca-cola-promo': { key: 'coca-cola-promo', name: 'CC Promo', color: 'B91C1C', textColor: 'FEF2F2', upc: '5449000000996' },
  'coca-cola-xmas': { key: 'coca-cola-xmas', name: 'CC Xmas', color: '991B1B', textColor: 'FDE68A', upc: '5449000000996' },
  'cola-zero': { key: 'cola-zero', name: 'Cola Zero', color: '171717', textColor: 'FFF', upc: '5449000131805' },
  'cola-zero-carton': { key: 'cola-zero-carton', name: 'CZ 24pk', color: '0A0A0A', textColor: 'A3A3A3', upc: '5449000131805' },
  'cola-cherry': { key: 'cola-cherry', name: 'Cola Cherry', color: '991B1B', textColor: 'FFF', upc: '5449000000224' },
  'diet-coke': { key: 'diet-coke', name: 'Diet Coke', color: 'CBD5E1', textColor: '1E293B', upc: '5449000050205' },
  'sprite': { key: 'sprite', name: 'Sprite', color: '16A34A', textColor: 'FFF', upc: '5449000014535' },
  'sprite-zero': { key: 'sprite-zero', name: 'Sprite Zero', color: '166534', textColor: 'BBF7D0', upc: '5449000014542' },
  'fanta': { key: 'fanta', name: 'Fanta', color: 'EA580C', textColor: 'FFF', upc: '5449000011527' },
  'fanta-lemon': { key: 'fanta-lemon', name: 'Fanta Lemon', color: 'EAB308', textColor: '422006', upc: '5449000011534' },
  'pepsi': { key: 'pepsi', name: 'Pepsi', color: '1E40AF', textColor: 'FFF', upc: '4060800100078' },
  'pepsi-max': { key: 'pepsi-max', name: 'Pepsi Max', color: '0F172A', textColor: 'FFF', upc: '4060800100085' },
  'dr-pepper': { key: 'dr-pepper', name: 'Dr Pepper', color: '7F1D1D', textColor: 'FFF', upc: '5000112547528' },
  'red-bull': { key: 'red-bull', name: 'Red Bull', color: '1D4ED8', textColor: 'FDE047', upc: '9002490100070' },
  'monster': { key: 'monster', name: 'Monster', color: '052E16', textColor: '4ADE80', upc: '5060166690199' },
  'monster-le': { key: 'monster-le', name: 'Monster LE', color: '052E16', textColor: 'F59E0B', upc: '5060166690199' },
  'lucozade': { key: 'lucozade', name: 'Lucozade', color: 'D97706', textColor: 'FFF', upc: '5010024009305' },
  'coca-cola-carton': { key: 'coca-cola-carton', name: 'Cola 24pk', color: 'B91C1C', textColor: 'FEE2E2', upc: '5449000000996' },
  'pepsi-carton': { key: 'pepsi-carton', name: 'Pepsi 24pk', color: '1E3A8A', textColor: 'DBEAFE', upc: '4060800100078' },
  'trash-blurry': { key: 'trash-blurry', name: 'Blurry Shelf', color: '6B7280', textColor: 'D1D5DB', upc: '0000000000000' },
};

/** Generates a product image URL with brand colors via placehold.co */
export function productImageUrl(product: MockProduct, suffix?: string): string {
  const text = suffix ? `${product.name} ${suffix}` : product.name;
  return `https://placehold.co/200x200/${product.color}/${product.textColor}?text=${encodeURIComponent(text)}&font=montserrat`;
}

/** Generates a numbered crop image URL (e.g., "Coca-Cola 0") */
export function productCropUrl(product: MockProduct, idx: number): string {
  return productImageUrl(product, `${idx}`);
}
